import { render, staticRenderFns } from "./physicianMeetingEx.vue?vue&type=template&id=e8b3c366&scoped=true"
import script from "./physicianMeetingEx.vue?vue&type=script&lang=js"
export * from "./physicianMeetingEx.vue?vue&type=script&lang=js"
import style0 from "./physicianMeetingEx.vue?vue&type=style&index=0&id=e8b3c366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b3c366",
  null
  
)

export default component.exports